{
  "name": "bene-mono-cli",
  "version": "0.0.20",
  "description": "A CLI to generate monorepo",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "author": {
    "name": "Benedict Lee",
    "url": "https://github.com/ailnk0"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/ailnk0/bene-mono.git",
    "directory": "packages/bene-mono-cli"
  },
  "files": [
    "dist",
    "README.md"
  ],
  "keywords": [
    "monorepo"
  ],
  "engines": {
    "node": ">=18"
  },
  "type": "module",
  "bin": "./dist/index.js",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "start": "node dist/index.js",
    "pub:release": "pnpm build && pnpm publish --access public"
  },
  "dependencies": {
    "commander": "^12.1.0",
    "execa": "^9.6.0",
    "fs-extra": "^11.3.1",
    "prompts": "^2.4.2"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^24.0.14",
    "@types/prompts": "^2.4.9",
    "@workspace/eslint-config": "workspace:*",
    "@workspace/typescript-config": "workspace:*",
    "eslint": "^9.33.0",
    "tsup": "^8.5.0",
    "typescript": "~5.8.3"
  }
}
